<div
  class="-homepage-container"
  [ngClass]="
    meta.type === 'Platforms'
      ? '-platforms'
      : meta.type === 'Enterprise'
      ? '-enterprise'
      : meta.type === 'Smb'
      ? '-smb'
      : meta.type === 'Payfac'
      ? '-payfac'
      : meta.type === 'Financial Institution'
      ? '-financial-institution'
      : meta.type === 'Independent Sales Org'
      ? '-independent-sales-organization'
      : meta.type === 'Independent Software Vendor'
      ? '-independent-software-vendor'
      : meta.type === 'customerexperience'
      ? '-customerexperience'
      : ''
  ">
  @if (body) {
  <content-viewer [content]="body" (docRendered)="handleDocRendered($event)"> </content-viewer>
  }
</div>
